import { useQuery } from '@tanstack/react-query';
import { offerPricingQueries, useEffectiveAuth } from './queries';
import type { WithCallWithAuth } from './queries';

export function useOfferPricingTotals(offerId: number, auth?: WithCallWithAuth) {
  const effectiveAuth = useEffectiveAuth(auth);
  return useQuery(offerPricingQueries.totals(effectiveAuth, offerId));
}
